<template>
  <div>
    <div class="header" :class="{'white': scrolled}">
      <div class="wrapper">
        <a href="#" class="logo" v-bind:class="{'is': isItPlatformaUser}" @click.prevent="onClickLogo"></a>
        <div class="header-right">
          <div class="menu">
            <a v-show="!item.hide" v-for="(item, index) in items" :class="{'act': active === item.alias}"
               :key="index" :href="item.href || '#'" @click.prevent="onClick(item)" :target="item.target">{{ item.name }}</a>
            <a
             class='header-support'
             href='https://yourfeedback.luxoft.com/aad/LandingPage/atFeedback?configuration=cfa87929-4193-40ed-973d-aa61005d384e&system=Loyality_portal'
             target='_blank'/>
          </div>
        </div>
      </div>

    </div>

    <a href="#" class="mob-menu-open" :class="{'close-menu': opened}" @click.prevent="opened = !opened"></a>

    <div class="mob-menu-overlay" :class="{'show': opened}">
      <div class="menu">
        <a v-for="(item, index) in items" :key="index" :class="{'act': active === item.alias}"
          :href="item.href || '#'" @click.prevent="onClick(item)" :target="item.target">{{ item.name }}</a>
        <a
        class='header-support type-mobile'
        href='https://yourfeedback.luxoft.com/aad/LandingPage/atFeedback?configuration=cfa87929-4193-40ed-973d-aa61005d384e&system=Loyality_portal'
        target='_blank'/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import throttle from 'lodash/throttle'

import VueScrollTo from 'vue-scrollto';

let options = {
  easing: 'ease-out',
  offset: -120,
  force: true,
  cancelable: true,
  onStart: function(element) {
    // scrolling started
  },
  onDone: function(element) {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  name: 'AppHeader',
  props: {
    items: {
      type: Array
    }
  },
  data () {
    return {
      scrolled: false,
      opened: false,
      active: false
    }
  },
  computed: {
    ...mapGetters(['remoteConfig', 'isItPlatformaUser'])
  },
  methods: {
    onClickLogo () {
      window.scrollTo(0, 0)
    },
    onClick (item) {
      this.opened = false
      if (item.ref) {
//        this.$emit('onSelect', item)
        VueScrollTo.scrollTo(item.ref.$el, 400, options)
      }
      else if (item.emit) {
        this.$eventBus.$emit(item.emit.event, item.emit.param)
      }
      else {
        window.open(item.href, item.target)
      }
      return false
    },
    onScroll () {
      let scrolled = parseInt(window.pageYOffset || document.documentElement.scrollTop)
      if (scrolled > 0) {
        this.scrolled = true
      } else {
        this.scrolled = false
      }
      if (!this.items) return;
      let items = this.items.filter(item => !item.hide && !item.noScroll && item.ref)
      if (!items) return
      let scrolledItems = items.filter(item => {
        let rect = item.ref.$el && item.ref.$el.getBoundingClientRect()
        if (!rect) return
        let headerHeight = document.querySelector('.header').clientHeight
//        let lineHeight = document.querySelector('.line').clientHeight
        let offsetY = parseInt(rect.top + window.pageYOffset - headerHeight + options.offset)
        return offsetY <= scrolled
      })
      if (scrolledItems && scrolledItems.length) {
        this.active = scrolledItems.pop().alias
      }
    }
  },
  mounted () {
    this.$eventBus.$on("scrollToGifts", () => this.onClick(this.items && this.items.find(x => x.alias==="gifts")));
  },
  beforeMount () {
    this.onScroll()
    window.addEventListener('scroll', throttle(this.onScroll, 100))
  },
  beforeDestroy () {
    window.removeEventListener('scroll', throttle(this.onScroll, 100))
  }
}
</script>
